import { render, staticRenderFns } from "./InsMenuItem.vue?vue&type=template&id=51c81d1c&scoped=true"
import script from "./InsMenuItem.vue?vue&type=script&lang=ts"
export * from "./InsMenuItem.vue?vue&type=script&lang=ts"
import style0 from "./InsMenuItem.vue?vue&type=style&index=0&id=51c81d1c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c81d1c",
  null
  
)

export default component.exports